@use "@fukuri-admins/ui/layout" as *;

.screen {
  padding-left: $SideMenuWidth;
  min-height: 100vh;
  @media screen and (max-width: $TB) {
    padding-left: 0;
    padding-top: 40px;
  }
}

.bannerWrapper {
  position: fixed;
  bottom: spacing('24');
  right: spacing('24');
}

